(ns pfo.im.controller
  (:require [pfo.api :as api :refer [process-error]]
            [pfo.util :as util]
            [promesa.core :as p]
            [keechma.next.controller :as ctrl]))

(derive :im-conversations :keechma/controller)
(defmethod ctrl/handle :im-conversations
  [{:keys [state*] :as ctrl} event {:keys [on-success on-error]}]
  (case event
    :load (->> (api/ajaxp "/im/conversations" {:disable-loadin-counter true})
               (p/map (fn [resp]
                        (ctrl/transact ctrl #(reset! state* resp))
                        (some-> on-success (apply [resp]))))
               (p/error (or on-error (fn [e] (throw e))))
               (process-error))
    :clear (reset! state* nil)
    nil))

(derive :im-create-conversation :keechma/controller)
(defmethod ctrl/handle :im-create-conversation
  [{:keys [state*] :as ctrl} event {:keys [kind participant-ids name family-id on-success on-error]}]
  (case event
    :load (->> (api/ajaxp "/im/conversations"
                          {:method :post
                           :body   (util/make-params
                                    (util/remove-nil-values {:kind            kind
                                                             :participant_ids participant-ids
                                                             :name            name
                                                             :family_id       family-id}))})
               (p/map (fn [resp]
                        (ctrl/transact ctrl #(reset! state* resp))
                        (some-> on-success (apply [resp]))))
               (p/error (or on-error (fn [e] (throw e))))
               (process-error))
    :clear (reset! state* nil)
    nil))

(derive :im-get-conversation :keechma/controller)
(defmethod ctrl/handle :im-get-conversation
  [{:keys [state*] :as ctrl} event {:keys [conv-id on-success on-error]}]
  (case event
    :load (->> (api/ajaxp (str "/im/conversations/" conv-id) {})
               (p/map (fn [resp]
                        (ctrl/transact ctrl #(reset! state* resp))
                        (some-> on-success (apply [resp]))))
               (p/error (or on-error (fn [e] (throw e))))
               (process-error))
    :clear (reset! state* nil)
    nil))

(derive :im-get-messages :keechma/controller)
(defmethod ctrl/handle :im-get-messages
  [{:keys [state*] :as ctrl} event {:keys [conv-id before-id on-success on-error]}]
  (case event
    :load (->> (api/ajaxp (str "/im/conversations/" conv-id "/messages")
                          {:params              (util/remove-nil-values {:before_id before-id :limit 50})
                           :disable-loadin-counter true})
               (p/map (fn [resp]
                        (ctrl/transact ctrl #(reset! state* resp))
                        (some-> on-success (apply [resp]))))
               (p/error (or on-error (fn [e] (throw e))))
               (process-error))
    :clear (reset! state* nil)
    nil))

(derive :im-send-message :keechma/controller)
(defmethod ctrl/handle :im-send-message
  [_ctrl event {:keys [conv-id content on-success on-error]}]
  (case event
    :send (->> (api/ajaxp (str "/im/conversations/" conv-id "/messages")
                          {:method                :post
                           :body                  (util/make-params {:body content})
                           :disable-loadin-counter true})
               (p/map (fn [resp] (some-> on-success (apply [resp]))))
               (p/error (or on-error (fn [e] (throw e))))
               (process-error))
    nil))

(derive :im-mark-read :keechma/controller)
(defmethod ctrl/handle :im-mark-read
  [_ctrl event {:keys [conv-id]}]
  (case event
    :mark (-> (api/ajaxp (str "/im/conversations/" conv-id "/read")
                         {:method :post :disable-loadin-counter true})
              (p/catch (fn [_] nil)))
    nil))

(derive :im-ack-message :keechma/controller)
(defmethod ctrl/handle :im-ack-message
  [_ctrl event {:keys [msg-id]}]
  (case event
    :ack (-> (api/ajaxp (str "/im/messages/" msg-id "/ack")
                        {:method :post :disable-loadin-counter true})
             (p/catch (fn [_] nil)))
    nil))

(derive :im-typing :keechma/controller)
(defmethod ctrl/handle :im-typing
  [_ctrl event {:keys [conv-id]}]
  (case event
    :send (-> (api/ajaxp (str "/im/conversations/" conv-id "/typing")
                         {:method :post :disable-loadin-counter true})
              (p/catch (fn [_] nil)))
    nil))
